import NumericSmokingWithoutLabels from "./NumericSmokingWithoutLabels";
export default NumericSmokingWithoutLabels;
